import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {UserGroupTypeSearch} from "./UserGroupTypeSearch";
import {SalesAreaSearch} from "../PA.UIM.MD/SalesAreaSearch";
import * as _ from "lodash";

const vUI_UserGroup_Search_Fields: {[id:string]: ISearchProviderField } =
    {
        WB_USRGRP_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'User Group WB Id',  columnResourceName: 'colUsrGrpWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
        USRGRP_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Group Id',     columnResourceName: 'colUsrGrpId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
        USRGRP_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Group Name',   columnResourceName: 'colUsrGrpName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},

        WB_USRGRPM_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'User Group Type WB Id',  columnResourceName: 'colUsrGrpMWBId',      alignment: HorizAlignment.Center}, domainOptions: { maxLength: 256,  search: UserGroupTypeSearch, profileId: "default", searchCondition: {}}},
        USRGRPM_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Group Type',   columnResourceName: 'colUsrGrpType',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},

       MDSET_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'MD Set',   columnResourceName: 'colUsrGrpMDset',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},

       SALESORG_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Sales Org',   columnResourceName: 'colUsrGrpSalesOrg',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
       WB_SALESAREA_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Group Type WB Id',  columnResourceName: 'colUsrGrpSARWBId',      alignment: HorizAlignment.Center},
            domainOptions: { maxLength: 256,  search: SalesAreaSearch, profileId: "default", searchCondition: {}}},

       ALL_SALES_AREAS:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Sales Area',   columnResourceName: 'colUsrGrpSalesArea',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
       USER_COUNT: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'No. of Users',   columnResourceName: 'colUsrGrpUsers',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
       CREATED_DT: { type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created Date', columnResourceName: 'colCreateDt', alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy"}, domainOptions: {}},
       MODIFIED_DT: {type: SearchProviderFieldType.sapdate, renderOptions: {columnName: 'Modified Date', columnResourceName: 'colModifiedDt', alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy"}, domainOptions: {}}
    }

const UserGroupSearchProviderBasic: ISearchProvider =
    {
        keyFields: {id:    'WB_USRGRP_ID',
            id_ui: 'USRGRP_ID',
            name:  'USRGRP_NAME'},


        searchProviderFields: vUI_UserGroup_Search_Fields,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_UserGroup_Search',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        let displayFields: string[] = <string[]>_.uniq(_.concat([
                            'USRGRP_ID','USRGRP_NAME', 'USRGRPM_NAME', 'MDSET_NAME','SALESORG_NAME', 'ALL_SALES_AREAS', 'USER_COUNT', 'CREATED_DT', 'MODIFIED_DT'
                        ], Object.values(this.keyFields)))
                        let returnVals: any[] = []
                        _.forEach(res, aRow => {
                            let aVal: { [id: string]: any } = {}
                            _.forEach(displayFields, aField => {
                                aVal[aField] = aRow[aField]
                            })
                            if (!_.filter(returnVals, aRow=>JSON.stringify(aVal)==JSON.stringify(aRow)).length) {
                                returnVals.push(aVal)
                            }
                        })
                        resolve(returnVals)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    }

const UserGroupSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UserGroupSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'User Group Id',     searchProviderFieldId: 'USRGRP_ID',   renderOptions: { }},
        {profileFilterName: 'User Group Name',   searchProviderFieldId: 'USRGRP_NAME', renderOptions: { }},
        {profileFilterName: 'User Group Type',  searchProviderFieldId: 'WB_USRGRPM_ID',    bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Sales Area',  searchProviderFieldId: 'WB_SALESAREA_ID',    bMultiSelect: true, renderOptions: { }}

    ],  // ISearchFields
    profileDisplayFields: [
        'USRGRP_ID','USRGRP_NAME', 'USRGRPM_NAME', 'MDSET_NAME','SALESORG_NAME', 'ALL_SALES_AREAS', 'USER_COUNT', 'CREATED_DT', 'MODIFIED_DT'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UserGroupSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const UserGroupSearch: ISearch = {
    searchName: "Find User Group",
    renderOptions: { ui5ResourceId: "UserGroupSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UserGroupSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("UserGroupBO", "UserGroup", UserGroupSearch, "User Group Search")

export {UserGroupSearch}